import styled from 'styled-components';
import { ResponsiveHeading } from '../PageHeading/pageHeading.style';

export const SessionExpiredOverlayRoot = styled.div`
    position: relative;
    z-index: 10000;
`;

export const SessionExpiredOverlayContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    text-align: center;
`;

export const SessionExpiredMessage = styled(ResponsiveHeading)`
    color: ${({ theme }) => theme.uiBricks?.secondaryFontColor || '#636569'};
`;
